export default __webpack_public_path__ + "static/Large_Storage_Box-4e5423833ab2b3fbc74a33dbeb5dab19.png";